/**
 * Base URL for nfib.com marketing site (header/footer links, theme CSS, bundled HTML).
 *
 * Override at build time: REACT_APP_NFIB_PUBLIC_SITE_BASE=https://example.com
 *
 * Or set tier: REACT_APP_NFIB_SITE_ENV = staging | qa | dev | ua | uat | production
 * - Dev & QA → staging Kinsta
 * - UA / UAT → UAT Kinsta
 * - Production → www.nfib.com
 */

const STAGING_ORIGIN = 'https://stg-nfibcom-staging.kinsta.cloud';
const UAT_ORIGIN = 'https://env-nfibcom-uat.kinsta.cloud';
const PROD_ORIGIN = 'https://www.nfib.com';

function normalizeOrigin(url) {
  if (!url || typeof url !== 'string') {
    return PROD_ORIGIN;
  }
  const t = url.trim();
  if (!t) {
    return PROD_ORIGIN;
  }
  return t.replace(/\/$/, '');
}

/**
 * Canonical origin for the nfib.com public site (no trailing slash).
 * @returns {string}
 */
export function getNfibPublicSiteOrigin() {
  const explicit = process.env.REACT_APP_NFIB_PUBLIC_SITE_BASE;
  if (explicit) {
    return normalizeOrigin(explicit);
  }

  const tier = (
    process.env.REACT_APP_NFIB_SITE_ENV ||
    process.env.REACT_APP_NFIB_ENV ||
    ''
  )
    .toString()
    .trim()
    .toLowerCase();

  if (tier === 'uat' || tier === 'ua') {
    return UAT_ORIGIN;
  }
  if (
    tier === 'staging' ||
    tier === 'qa' ||
    tier === 'dev' ||
    tier === 'development'
  ) {
    return STAGING_ORIGIN;
  }
  if (tier === 'production' || tier === 'prod') {
    return PROD_ORIGIN;
  }

  if (process.env.NODE_ENV === 'development') {
    return STAGING_ORIGIN;
  }

  return PROD_ORIGIN;
}

export const NFIB_PUBLIC_SITE_ORIGIN = getNfibPublicSiteOrigin();

/**
 * Where theme CSS / bundled image assets are loaded from. Staging/UAT often use
 * different hashed CSS filenames than production, so we default to production
 * for `/wp-content/...` asset URLs to keep header/footer styling stable.
 * Override: REACT_APP_NFIB_THEME_ASSET_BASE
 */
export const NFIB_THEME_ASSET_ORIGIN = normalizeOrigin(
  process.env.REACT_APP_NFIB_THEME_ASSET_BASE || PROD_ORIGIN
);

/**
 * Rewrite bundled header/footer HTML: navigation/page links use the env
 * marketing site, but `/wp-content/` asset URLs stay on {@link NFIB_THEME_ASSET_ORIGIN}.
 * @param {string} html
 * @param {string} [origin] marketing site origin for non-asset links
 * @returns {string}
 */
export function rewriteNfibPublicSiteUrlsInHtml(html, origin) {
  const o = normalizeOrigin(origin || NFIB_PUBLIC_SITE_ORIGIN);
  if (!html || typeof html !== 'string') {
    return html;
  }
  return html
    .replace(/https:\/\/www\.nfib\.com(?!\/wp-content)/g, o)
    .replace(/http:\/\/www\.nfib\.com(?!\/wp-content)/g, o)
    .replace(/https:\/\/nfib\.com(?!\/wp-content)/g, o)
    .replace(/http:\/\/nfib\.com(?!\/wp-content)/g, o);
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/nfibPublicSite.js